import React from 'react';
import { Section } from '@layout';
import { Button } from '@input';

export default function GetInTouch() {
  return (
    <Section
      maxContentWidth={800}
      textAlign="center"
    >
      <h2>Get in touch</h2>
      <p>
        For more information on CDLS and our mission please see our annual
        report. You can get in touch with our Director, Aradhna Tripati, by
        emailing her at{' '}
        <a href="mailto:atripati@g.ucla.edu">atripati@g.ucla.edu</a>{' '}
      </p>
      <Button
        icon="book"
        href="/cdls-annual-report.pdf"
      >
        Read Annual Report
      </Button>
    </Section>
  );
}
